import { Eye, EyeOff } from 'lucide-react'
import { useArtistViewMode } from '@/hooks/useArtistViewMode'
import { withViewTransition } from '@/lib/viewTransition'
import type { RolNivel } from '@/types'

// Small header toggle shown only to Artists (rol_nivel='B'). Flips between
// 'mine' (personal schedule — public + assigned) and 'all' (every activity
// in the tour). Managers and Crew don't see this; it would confuse Crew and
// be redundant for Managers.
//
// The role prop is TOUR-scoped (read from tour_memberships for the active
// tour). Keeps the toggle driven by the manager's explicit assignment for
// THIS tour, even when it diverges from the user's baseline org role.

interface Props {
  role: RolNivel | null | undefined
}

export function ArtistViewToggle({ role }: Props) {
  const { mode, toggle } = useArtistViewMode()

  if (role !== 'B') return null

  const showingAll = mode === 'all'

  return (
    <button
      onClick={() => withViewTransition(toggle)}
      className="text-muted-foreground hover:text-foreground transition-colors p-2"
      aria-label={showingAll ? 'Show only my schedule' : 'Show the full tour schedule'}
      title={showingAll ? 'Showing all activities — click for my schedule only' : 'Showing my schedule only — click to see everything'}
    >
      {showingAll
        ? <Eye className="w-5 h-5" strokeWidth={2} />
        : <EyeOff className="w-5 h-5" strokeWidth={2} />}
    </button>
  )
}
